<div class="cv-overview-sub-header">
	<cv-order-info [orderInboxModel]="orderInboxModel"></cv-order-info>
	<div class="buttons float-right">
		<cv-users-info [orderUsers]="orderUsers"></cv-users-info>
		<cv-ci-sub-header-lock-button [orderInboxModel]="orderInboxModel"></cv-ci-sub-header-lock-button>
		<cv-overview-sub-header-available-pdf *ngIf="orderInboxModel.stateEnum === orderStatus.APPROVED">
		</cv-overview-sub-header-available-pdf>
		<cv-download-buttons [orderInboxModel]="orderInboxModel"></cv-download-buttons>
		<cv-approve-reject-buttons></cv-approve-reject-buttons>
	</div>
</div>
